import { useMemo } from 'react'

import { createPermissions } from '@mntn-dev/session-manager'
import { useMe } from './use-me.ts'

function usePermissions() {
  const { me } = useMe()
  const { organizationType } = me

  const permissions = useMemo(
    () => createPermissions({ organizationType }),
    [organizationType]
  )

  return permissions
}

export { usePermissions }
